
import { defineComponent, computed, ref, watch, nextTick } from 'vue'
import { truncateText, takeFirst } from '@/utils/arkOneUtils'
import { zh_tran } from '@/utils/lang.js'

const __default__ = defineComponent({
  name: 'StrategyHeader',
  props: {
    name: {
      type: String,
      required: true
    },
    tags: {
      type: Array as () => string[],
      default: () => []
    },
    highlights: {
      type: String,
      default: ''
    },
    // 主题：'dark' | 'light'
    theme: {
      type: String,
      default: 'dark'
    },
    // 语言支持：'zh-Hans' 简体中文，'zh-Hant' 繁体中文
    language: {
      type: String,
      default: 'zh-Hans'
    }
  },
  setup(props) {
    // 风险提示弹框显示状态
    const isRiskWarningVisible = ref(false)
    const isTraditional = computed(() => props.language === 'zh-Hant')

    // 判断是否有数据
    const hasData = computed(() => {
      return props.name !== '' || props.tags.length > 0 || props.highlights !== ''
    })

    // 策略名称最多显示10个字符
    const displayName = computed(() => {
      return truncateText(props.name, 10, false)
    })

    // 标签最多显示3个
    const displayTags = computed(() => {
      return takeFirst(props.tags, 3)
    })

    // 组合亮点最多显示100个字符
    const displayHighlights = computed(() => {
      return truncateText(props.highlights, 100, false)
    })

    // 显示风险提示弹窗
    const showRiskWarning = () => {
      isRiskWarningVisible.value = true
    }

    // 关闭风险提示弹窗
    const closeRiskWarning = () => {
      isRiskWarningVisible.value = false
    }

    // 弹窗内容是“后渲染”的，打开时补一次转换避免遗漏
    watch(isRiskWarningVisible, (visible) => {
      if (visible && isTraditional.value) {
        nextTick(() => {
          zh_tran('t')
        })
      }
    })

    return {
      hasData,
      displayName,
      displayTags,
      displayHighlights,
      isRiskWarningVisible,
      showRiskWarning,
      closeRiskWarning
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "f5a87b28": (_ctx.theme === "light" ? "#ffffff" : "#1A1D2F"),
  "9ed8e8fa": (_ctx.theme === "light" ? "#000000" : "#ffffff"),
  "7de4614c": (_ctx.theme === "light" ? "#636363" : "#999999"),
  "9db1b33a": (_ctx.theme === "light" ? "#333333" : "#ffffff")
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__